import { useEffect, useState } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { loadEmpresaYConfigParaPdf } from '@/lib/pdfBranding';
import type { DocumentConfig, EmpresaInfo } from '@/lib/pdfDocumentEngine';

/**
 * Carga la personalización de documentos (colores, logo, pie de página, texto legal)
 * de la empresa del usuario para usarla al generar PDFs.
 */
export function useDocumentConfig(override?: Partial<DocumentConfig>) {
  const { perfil } = useAuth();
  const empresaId = perfil?.empresa_id;
  const [empresaPdf, setEmpresaPdf] = useState<EmpresaInfo | null>(null);
  const [loaded, setLoaded] = useState<Partial<DocumentConfig> | undefined>(undefined);

  useEffect(() => {
    let cancel = false;
    if (!empresaId) {
      setEmpresaPdf(null);
      setLoaded(undefined);
      return;
    }
    loadEmpresaYConfigParaPdf(empresaId)
      .then(({ empresa, docConfig }) => {
        if (cancel) return;
        setEmpresaPdf(empresa);
        setLoaded(docConfig);
      })
      .catch(() => {
        if (!cancel) setLoaded(undefined);
      });
    return () => {
      cancel = true;
    };
  }, [empresaId]);

  return {
    empresaPdf,
    docConfig: override ?? loaded,
  };
}
